import * as Yup from "yup";

import { PASSWORD_REGEX } from "./constants";

/**
 * Canonical client-side password rule for every set-password form. The
 * Django backend (`AUTH_PASSWORD_VALIDATORS`) enforces these same rules plus
 * common-password and user-attribute similarity checks — those are not
 * replicated client-side because the wordlist / fuzzy match aren't worth
 * shipping in the bundle.
 */
export const passwordYupRule = Yup.string()
  .min(12, "Password must be at least 12 characters long")
  .matches(/^(?![0-9]+$)/, "Password cannot be entirely numeric")
  .matches(
    new RegExp(PASSWORD_REGEX),
    "Password must include uppercase, lowercase, number, and a special character (!@#$%^&*)",
  )
  .required("Password is required");
